module.exports = require("./fr-CI.d.ts");